import React from 'react';
import './MapChart.scss';
import { useSelector } from 'react-redux';


export const MapChart = function({ data }) {
	const cmsMediaPath = useSelector(state => state.config.basePath + state.config.apiMediaPath);

	return (
		<div className='map-chart'>
			<div className='map-chart-bg'>
				<img src={cmsMediaPath + data.Map}/>
			</div>
			<div className='map-chart-fg'>
				<img src={cmsMediaPath + data.Overlay}/>
			</div>
		</div>
	);
};